import React, { useState, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import InputSelect from '../../../PropertySearch/Custom/CustomInput/InputSelect'
import listContext from '../../../Common/context/context'
import keycloak from '../../../keycloak'
import { rentCompAvgCalc } from '../../Utility/PropertyListUtility'
import { getUserSFId } from '../../../PropertySearch/Utility/Utility'
import { modifyUnitMixSourcePreference } from '../../Services/PropertyListService'

const SelectUnitMixSource = props => {

    const { propertyList, setPropertyList } = useContext(listContext)
    const { propertyId, source, setSource } = props
    // const [source, setSource] = useState(props.source)
    const [sourceOptions, setSourceOptions] = useState([])

    useEffect(() => {
        if (propertyId) {
            getSourceOptions()
        }
    }, [propertyId])

    useEffect(() => {
        if (source) {
            updateDataBySource()
        }
    }, [source])

    const getSourceOptions = () => {

        let returnSource = []

        try {
            if (propertyList && propertyList.compsList) {

                const row = propertyList.compsList.filter(x => x.omniViewPropertyId === propertyId)
                const data = row[0].data

                if (data && data.omniviewpropertyrent) {
                    const distinctSource = [...new Set(data.omniviewpropertyrent.map(x => x.source))]

                    for (var i = 0; i < distinctSource.length; i++) {
                        returnSource.push({
                            label: distinctSource[i], value: distinctSource[i]
                        })
                    }
                }
            }
        } catch (error) {
            console.log('error in getSourceOptions:::', error)
        }

        setSourceOptions(returnSource)
    }

    const updateDataBySource = () => {

        try {
            if (propertyList && propertyList.compsList) {
                const rowIndex = propertyList.compsList.findIndex(x => x.omniViewPropertyId === propertyId)

                if (rowIndex !== -1) {
                    let newPropertyList = { ...propertyList }
                    newPropertyList.compsList[rowIndex].sourcePreference = source
                    setPropertyList(newPropertyList)
                    rentCompAvgCalc(newPropertyList, setPropertyList)
                }
            }
        } catch (error) {
            console.log('error in updateDataBySource:::', error)
        }

    }

    const handleChange = event => {
        const newSource = event.target.value

        setSource(newSource)

        updateSource(newSource)
    }

    const updateSource = newSource => {

        try {
            if (propertyList && propertyList.compsList) {
                const rowIndex = propertyList.compsList.findIndex(x => x.omniViewPropertyId === propertyId)

                if (rowIndex !== -1) {
                    const user_SFId = getUserSFId()

                    let paylaod =
                    {
                        "omniViewPropertyListId": propertyList.omniViewPropertyListId ? propertyList.omniViewPropertyListId : '',
                        "polarisPropertySearchCriteriaId": propertyList.polarisPropertySearchCriteriaId ? propertyList.polarisPropertySearchCriteriaId : '',
                        "omniViewPropertyId": propertyId,
                        "sourcePreference": newSource,
                        // "userId": keycloak.subject,
                        "lastModifiedById": user_SFId,
                        "polarisLastModifiedById": keycloak.subject,
                        "polarisLastModifiedByUserName": keycloak.tokenParsed.name
                    }

                    modifyUnitMixSourcePreference(paylaod)
                }
            }
        } catch (error) {
            console.log('error in updateDataBySource:::', error)
        }

    }

    return (
        <>
            {sourceOptions.length ?
                <InputSelect id="" optionsList={sourceOptions} onChange={handleChange} testid={'test-select-UM-source'} value={source} classes="width-source-dropdown"></InputSelect>
                : null}
        </>
    )

}

export default SelectUnitMixSource

SelectUnitMixSource.propTypes = {
    propertyId: PropTypes.any,
    source: PropTypes.any,
    setSource: PropTypes.any
}
